import React from 'react'
import {findDOMNode} from "react-dom";

const debug = false
// const debug = "UIRightPanel"

type Props = {

}

type State = {
    isOpen      : boolean,
    styles      : any,
    component   : any,
}

export default class UIRightPanel extends React.Component<Props, State> {

    public app              : any
    public panelComponent   : any // I added this to prevent TS errors - need to check what's that

    constructor(props:Props) {
        super(props);

        this.state = {
            styles      : null,
            isOpen      : false,
            component   : false
        }

        debug && console.log(debug, "constructor")
    }

    componentDidMount() {
        gd.layout.right = this
    }

    componentDidUpdate(prevProps:any, prevState:any, snapshot:any) {
        // if custom width is set then it should be also passed to child component
        // child component width should be static while this panel width is animated
        if (this.state.component && this.state.styles.width) {
            const node : any = findDOMNode(this)
            // do not override child component width if it already defined in style
            if (!node.firstChild.style.width) node.firstChild.style.setProperty("width", this.state.styles.width + "px")
        }
    }

    get isOpen() {
        return this.state.isOpen
    }

    get component() {
        return this.state.component
    }

    hide = () => {
        debug && console.log(debug, "hide")

        this.destroyApp()

        // do nothing if not needed
        if (!this.state.isOpen && !this.state.component) return

        this.setState({
            isOpen      : false,
            component   : false,
            styles      : null
        }, ()=>{gd.bus.triggerEvent('ui-right-panel:hide')})

    }

    show = (component:any, styles = {}) => {
        debug && console.log(debug, "show", component, styles)

        this.destroyApp()

        // Experimental
        if (this.state.isOpen) {

            this.setState({
                isOpen      : false,
                component   : false,
                styles      : null
            }, ()=>{
                gd.bus.triggerEvent('ui-right-panel:hide')

                setTimeout(()=>{

                    this.setState({
                            component   : component,
                            isOpen      : true,
                            styles      : styles
                        }, ()=>{
                            gd.bus.triggerEvent('ui-right-panel:show', component)}
                    )
                }, 1)

            })
        } else {

            this.setState({
                    component   : component,
                    isOpen      : true,
                    styles      : styles
                }, ()=>{
                    gd.bus.triggerEvent('ui-right-panel:show', component)}
            )

        }
        // End
    }

    // New Used in AI chat
    async loadAndRun(LoaderClass:any) {

        this.setState({component: null, isOpen: true}, ()=> {
            gd.bus.triggerEvent('ui-right-panel:show', null)})

        debug && console.log(debug, "Right panel loadAndRun()","App=",LoaderClass);

        if (!LoaderClass) {
            throw Error("#hdfgsgers LoaderClass is broken")
        }

        // ResourceLoaderProto
        const resourceLoader = new LoaderClass();

        try {
            const App = await resourceLoader.load();

            this.launchApp(App, {domContainerId: "ui-right"})

        } catch (e) {
            console.error(e, "Something is wrong in app loading...")
        }
    }

    // New Used in AI chat
    async launchApp(AppClass : any,params:any={}):Promise<any> {

        gd.appManager.destroyModal()
        gd.appManager.destroyItemView({onAppLaunch: true})
        gd.appManager.destroyAnalytics()
        gd.appManager.destroyFullModal()

        try {
            this.app = new AppClass(params)

            await this.app.init(params)

            this.app.start();

        } catch (e) {
            console.error(e)
        }
    }

    destroyApp() {
        debug && console.log(debug,".destroyApp()", this.app);

        if (!!this.app?.destructor) {
            this.app.destructor()
        }

        this.app = null
    }

    render() {
        debug && console.log(debug, "constructor", this.state)

        const classes = Classes("ui-right", {
            'open'  : this.state.isOpen,
            'closed': !this.state.isOpen,
        })

        const styles = this.state.isOpen ? this.state.styles : null

        return (
            <div id="ui-right" className={classes} style={styles}>
                {this.state.isOpen && this.state.component}
            </div>
        )
    }
}

